import React from 'react';
import './Banner.scss';
import { useLanguage } from '../../context/LanguageContext';
import translationsEN from '../../translations/en.json';
import translationsFR from '../../translations/fr.json';

const Banner = () => {
  const { language } = useLanguage();
  const t = language === 'fr' ? translationsFR : translationsEN;

  // const fromDay = t.banner.fromDay;
  // const toDay = t.banner.toDay;
  // const fromTime = '18:00';
  // const toTime = t.banner.late;
  const closedMessage = t.banner.closed;

  const bannerItems = Array(8).fill(null);

  return (
    <div className='banner'>
      <p className='banner__text'>
        {bannerItems.map((_, index) => (
          <React.Fragment key={index}>
            <span className='banner__day'>
              {/* {'\u00A0\u00A0\u00A0'} {fromDay} - {toDay} {fromTime} - {toTime} */}
              {'\u00A0\u00A0\u00A0'} {closedMessage}
              {'\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0'}
            </span>
          </React.Fragment>
        ))}
      </p>
    </div>
  );
};

export default Banner;
